// Estimated time remaining for a running job, from the progress rate observed in this browser.
// Each job phase is measured separately (its total changes between phases). No estimate is shown until
// enough progress has been seen to be meaningful.

interface Sample {
  key: string;
  t0: number;
  done0: number;
}

const samples = new Map<number, Sample>();
const MIN_SECONDS = 15;
const MIN_ITEMS = 3;

export function etaSeconds(job: { id: number; status: string; phase: string | null; progress_done: number; progress_total: number }): number | null {
  if (job.status !== "running" || job.progress_total <= 0) {
    samples.delete(job.id);
    return null;
  }
  const key = `${job.phase}:${job.progress_total}`;
  const now = Date.now();
  const s = samples.get(job.id);
  if (!s || s.key !== key || job.progress_done < s.done0) {
    samples.set(job.id, { key, t0: now, done0: job.progress_done });
    return null;
  }
  const elapsed = (now - s.t0) / 1000;
  const progressed = job.progress_done - s.done0;
  if (elapsed < MIN_SECONDS || progressed < MIN_ITEMS) return null;
  const remaining = Math.max(0, job.progress_total - job.progress_done);
  return remaining / (progressed / elapsed);
}
